import { render } from "./DataTable.vue?vue&type=template&id=4baa40c5&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=4baa40c5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baa40c5"],['__file',"src/views/HistoricalData/FeedbackPage/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4baa40c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4baa40c5', __exports__)) {
    api.reload('4baa40c5', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=4baa40c5&scoped=true", () => {
    api.rerender('4baa40c5', render)
  })

}


export default __exports__